import { minutesFromTime, toDateKey } from './planningDates';

export const eventOccursOnDate = (event, date) => event.startDate <= date && (event.endDate || event.startDate) >= date;

export const getEventDaySegment = (event, date) => {
  if (!eventOccursOnDate(event, date) || event.isAllDay) return null;
  const startMinutes = event.startDate === date ? minutesFromTime(event.startTime) : 0;
  const endMinutes = (event.endDate || event.startDate) === date ? minutesFromTime(event.endTime) : 1440;
  return { ...event, segmentDate: date, startMinutes, endMinutes: Math.max(startMinutes + 1, endMinutes) };
};

export const layoutOverlappingEvents = (events = []) => {
  const sorted = [...events].sort((first, second) => first.startMinutes - second.startMinutes || first.endMinutes - second.endMinutes);
  const groups = [];
  sorted.forEach((event) => {
    const current = groups[groups.length - 1];
    if (!current || event.startMinutes >= current.endMinutes) groups.push({ endMinutes: event.endMinutes, events: [event] });
    else { current.events.push(event); current.endMinutes = Math.max(current.endMinutes, event.endMinutes); }
  });
  return groups.flatMap((group) => {
    const columnEnds = [];
    const placed = group.events.map((event) => {
      let column = columnEnds.findIndex((end) => end <= event.startMinutes);
      if (column < 0) column = columnEnds.length;
      columnEnds[column] = event.endMinutes;
      return { ...event, column };
    });
    const columnCount = Math.max(1, columnEnds.length);
    return placed.map((event) => ({ ...event, columnCount, leftPercent: (event.column / columnCount) * 100, widthPercent: 100 / columnCount }));
  });
};

export const layoutEventsForDate = (events, date) => layoutOverlappingEvents(events.map((event) => getEventDaySegment(event, date)).filter(Boolean));
export const getAllDayEventsForDate = (events, date) => events.filter((event) => event.isAllDay && eventOccursOnDate(event, date));
export const getNowMinutes = (date = new Date()) => date.getHours() * 60 + date.getMinutes();
export const isToday = (date, now = new Date()) => toDateKey(date) === toDateKey(now);
